import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, setToken, formatApiErrorDetail } from "../lib/api";
import Seo from "../lib/seo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      navigate("/admin/dashboard");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen flex flex-col justify-center max-w-md mx-auto px-6">
      <Seo title="RCKT Admin — Sign in" noindex />
      <Link to="/" className="font-display font-700 tracking-[0.18em] text-lg mb-12">RCKT</Link>
      <div className="label mb-3">Archive Admin</div>
      <h1 className="font-display font-700 text-3xl uppercase mb-10">Sign in</h1>
      <form onSubmit={submit} className="space-y-5">
        <div>
          <label className="label block mb-2">Email</label>
          <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full bg-white border hairline px-4 py-3 outline-none focus:border-[var(--ink)] transition-colors" />
        </div>
        <div>
          <label className="label block mb-2">Password</label>
          <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full bg-white border hairline px-4 py-3 outline-none focus:border-[var(--ink)] transition-colors" />
        </div>
        {err && <div className="text-sm text-red-700" data-testid="admin-error">{err}</div>}
        <button data-testid="admin-login-submit" disabled={loading}
          className="w-full bg-[var(--ink)] text-[var(--paper)] font-display uppercase tracking-[0.1em] text-sm py-3.5 hover:opacity-80 transition-opacity">
          {loading ? "…" : "Enter"}
        </button>
      </form>
      <Link to="/" className="label mt-10 hover:opacity-50 transition-opacity">← Back to site</Link>
    </main>
  );
}
